import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useRealtimeNotifications } from '../hooks/useRealtimeNotifications';

/**
 * Componente wrapper para inicializar notificações em tempo real
 * Deve ser usado dentro do AuthProvider
 */
const RealtimeNotificationsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  
  // Inicializar hook de notificações em tempo real
  useRealtimeNotifications();

  return <>{children}</>;
};

export default RealtimeNotificationsWrapper;

